module.exports = __webpack_public_path__ + "img/switcher.7c2f3bf0.svg";